// @flow
import * as React from 'react';

type Args = {
  direction: 'horizontal' | 'vertical',
};

export const useResizable = ({direction}: Args) => {
  const [resizedLength, setResizedLength] = React.useState<number>(0);
  const [isDragging, setIsDragging] = React.useState(false);

  const handleMouseDown = () => {
    const handleDrag = (e: MouseEvent) => {
      setIsDragging(true);

      if (direction === 'vertical') {
        setResizedLength((len) => len - e.movementY);
      } else {
        setResizedLength((len) => len + e.movementX);
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);

      document.removeEventListener('mousemove', handleDrag);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleDrag);
    document.addEventListener('mouseup', handleMouseUp);
  };

  return {resizedLength, isDragging, handleMouseDown};
};
